import dayjs from 'dayjs';
require('dayjs/locale/gl');
require('dayjs/locale/pt');
require('dayjs/locale/en');
require('dayjs/locale/de');
require('dayjs/locale/es');
const updateLocale = require('dayjs/plugin/updateLocale');
dayjs.extend(updateLocale);

export function setDayJsLocale(locale) {
  locale = locale.substr(0, 2);
  dayjs.locale(locale);

  switch (locale) {
    case 'es':
      dayjs.updateLocale('es', {
        calendar: {
          lastDay: '[Ayer a las] HH:mm',
          sameDay: '[Hoy a las] HH:mm',
          nextDay: '[Mañana a las] HH:mm',
          lastWeek: '[El último] dddd [a las] HH:mm',
          nextWeek: '[El] dddd [a las] HH:mm',
          sameElse: 'DD/MM/YYYY HH:mm'
        },
        relativeTime: {
          future: 'en %s',
          past: 'hace %s',
          s: 'unos segundos',
          m: 'un minuto',
          mm: '%d minutos',
          h: 'una hora',
          hh: '%d horas',
          d: 'un día',
          dd: '%d días',
          M: 'un mes',
          MM: '%d meses',
          y: 'un año',
          yy: '%d años'
        }
      });
      break;
    case 'pt':
      dayjs.updateLocale('pt', {
        calendar: {
          lastDay: '[Ontem ás] HH:mm',
          sameDay: '[Hoje ás] HH:mm',
          nextDay: '[Amanhã ás] HH:mm',
          lastWeek: '[Última] dddd [ás] HH:mm',
          nextWeek: 'dddd [ás] HH:mm',
          sameElse: 'DD/MM/YYYY HH:mm'
        },
        relativeTime: {
          future: 'em %s',
          past: '%s atrás',
          s: 'alguns segundos',
          m: 'um minuto',
          mm: '%d minutos',
          h: 'uma hora',
          hh: '%d horas',
          d: 'um dia',
          dd: '%d dias',
          M: 'um mês',
          MM: '%d meses',
          y: 'um ano',
          yy: '%d anos'
        }
      });
      break;
    case 'gl':
      dayjs.updateLocale('gl', {
        calendar: {
          lastDay: '[Onte ás] HH:mm',
          sameDay: '[Hoxe ás] HH:mm',
          nextDay: '[Mañán ás] HH:mm',
          lastWeek: '[O último] dddd [ás] HH:mm',
          nextWeek: '[O] dddd [ás] HH:mm',
          sameElse: 'DD/MM/YYYY HH:mm'
        },
        relativeTime: {
          future: 'en %s',
          past: 'fai %s',
          s: 'uns segundos',
          m: 'un minuto',
          mm: '%d minutos',
          h: 'unha hora',
          hh: '%d horas',
          d: 'un día',
          dd: '%d días',
          M: 'un mes',
          MM: '%d meses',
          y: 'un ano',
          yy: '%d anos'
        }
      });
      break;
    default:
      break;
  }
}
